import { render, staticRenderFns } from "./PolicyAndTermsYdoc.vue?vue&type=template&id=4b061d79&"
import script from "./PolicyAndTermsYdoc.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PolicyAndTermsYdoc.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b061d79')) {
      api.createRecord('4b061d79', component.options)
    } else {
      api.reload('4b061d79', component.options)
    }
    module.hot.accept("./PolicyAndTermsYdoc.vue?vue&type=template&id=4b061d79&", function () {
      api.rerender('4b061d79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/PolicyAndTermsYdoc.vue"
export default component.exports